import { CheckSquare, Bell, Shield, Wrench } from 'lucide-react'
import type { ActivityItem } from '@/hooks/useAgentActivity'

const typeIcons: Record<string, React.ElementType> = {
  tool_call: Wrench,
  notification: Bell,
  compliance_check: Shield,
}

function formatRelativeTime(timestamp: string): string {
  const diff = Date.now() - new Date(timestamp).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

interface ActivityEntryProps {
  item: ActivityItem
}

export function ActivityEntry({ item }: ActivityEntryProps) {
  const Icon = typeIcons[item.type] || CheckSquare

  return (
    <div className="flex items-start gap-3 px-3 py-2 hover:bg-accent/50 rounded-md transition-colors">
      <div className="flex-shrink-0 mt-0.5">
        <div className="h-7 w-7 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon className="h-3.5 w-3.5 text-primary" />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm">{item.summary}</p>
        {item.detail && (
          <p className="text-xs text-muted-foreground mt-0.5">{item.detail}</p>
        )}
      </div>
      <span className="text-xs text-muted-foreground whitespace-nowrap flex-shrink-0">
        {formatRelativeTime(item.timestamp)}
      </span>
    </div>
  )
}
